import { DialogContent } from "@mui/material";
import { APP_V2_USER_EVENTS } from "@src/appV2/lib/analytics";
import { useLogEffect } from "@src/appV2/lib/analytics/useLogEffect";
import { BottomSheetHeader } from "@src/appV2/redesign/components/BottomSheetHeader";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { BottomSheet, Text, type UseModalState } from "@src/appV2/redesign/system/ui-components";

import { CancellationProtectionTermsList } from "./CancellationProtectionTermsList";

interface CancellationProtectionTermsBottomSheetProps {
  modalState: UseModalState;
  cancellationProtectionWindowInHours: number;
  isSentHomeProtected: boolean;
  workplaceName: string;
  workplaceId?: string;
}

export function CancellationProtectionTermsBottomSheet(
  props: CancellationProtectionTermsBottomSheetProps
) {
  const {
    modalState,
    cancellationProtectionWindowInHours,
    isSentHomeProtected,
    workplaceName,
    workplaceId,
  } = props;

  useLogEffect(
    APP_V2_USER_EVENTS.CANCELLATION_PROTECTION_TERMS_BOTTOM_SHEET_VIEWED,
    { workplaceId, cancellationProtectionWindowInHours, isSentHomeProtected },
    { enabled: modalState.modalIsOpen }
  );

  return (
    <BottomSheet
      modalState={modalState}
      header={<BottomSheetHeader onClose={() => modalState.closeModal()} />}
      footer={
        <DialogFooter orientation="vertical">
          <Button
            fullWidth
            variant="contained"
            size="large"
            onClick={() => modalState.closeModal()}
          >
            Great!
          </Button>
        </DialogFooter>
      }
    >
      <DialogContent>
        <Text
          variant="body2"
          sx={{
            color: (theme) => theme.palette.text.secondary,
            textAlign: "center",
            paddingBottom: 9,
          }}
        >
          These terms only apply to {workplaceName} and may not apply to other workplaces
        </Text>
        <CancellationProtectionTermsList
          variant="shift"
          cancellationProtectionWindowInHours={cancellationProtectionWindowInHours}
          isSentHomeProtected={isSentHomeProtected}
        />
      </DialogContent>
    </BottomSheet>
  );
}
